import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserIdService } from '@spartacus/core';
import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnonymousInterceptor implements HttpInterceptor {
  userCurrent: string;

  constructor(protected auth: UserIdService) {
    this.auth.getUserId().subscribe((data) => {
      this.userCurrent = data;
    });
  }

  // Interceptor that blocks API requests when the user is in anonymous state
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const blockRequest: boolean = this.getEndpointsToBlock().some((u) => request.url.includes(u));
    if (this.userCurrent === 'anonymous' && blockRequest) {
      return EMPTY;
    }
    return next.handle(request);
  }

  getEndpointsToBlock(): string[] {
    // Add more APIs to block here
    const productApi = '/products';
    return [productApi];
  }
}
